import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegisterLinks } from './registerLinks';

const routes: Routes = [
  {
    path: 'registerLinks',
    component: RegisterLinks,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterLinksRoutingModule {}
